module.exports = __webpack_public_path__ + "static/media/aula.8072e841.jpg";